"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FileInputButtonHandler {
    constructor(input, button) {
        this.input = input;
        this.button = button;
    }
    /**
     * Setup the button to trigger the file input click event.
     */
    init() {
        let isOpeningFilePicker = false;
        this.button.addEventListener('focusout', () => {
            if (isOpeningFilePicker) {
                isOpeningFilePicker = false;
                return;
            }
            this.input.dispatchEvent(new Event('blur'));
        });
        this.button.addEventListener('click', () => {
            isOpeningFilePicker = true;
            this.button.focus();
            this.input.click();
        });
        this.input.addEventListener('focusin', (e) => {
            this.button.focus();
        });
    }
}
exports.default = FileInputButtonHandler;
